import { Box, lighten, Typography, useTheme } from '@mui/material';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';

import { SourceBreakdownItem } from '@/apis/agency/onboardingInsights/types';
import { BuilderEmptyStateView } from '@/components/Common/BuilderEmptyStateView';
import { titleCase } from '@/utils/helperFunctions';

interface Props {
  data: SourceBreakdownItem[];
}

export default function SourceBreakdownChart({ data }: Props) {
  const theme = useTheme();

  const chartData = data.map((item) => ({
    name: item.label,
    value: item.count,
    percentage: item.percentage
  }));

  const isAllZero = chartData.every((item) => item.value === 0);

  return (
    <Box bgcolor='#fff' border='1px solid #ECECEC' borderRadius={2} p={3} height='100%'>
      <Typography fontSize={20} fontWeight={500} mb={0.5}>
        Source
      </Typography>
      <Typography fontSize={14} color='text.secondary' mb={2}>
        Insight about from where new businesses are coming from
      </Typography>

      {chartData.length && !isAllZero ? (
        <ResponsiveContainer width='100%' height={420}>
          <PieChart>
            <Pie data={chartData} dataKey='value' innerRadius={90} outerRadius={140} paddingAngle={2}>
              {chartData.map((_, index) => (
                <Cell
                  key={index}
                  fill={index === 0 ? theme.palette.primary.main : lighten(theme.palette.primary.main, 0.7)}
                />
              ))}
            </Pie>
            <Legend
              verticalAlign='bottom'
              iconType='circle'
              formatter={(value) => (
                <span style={{ color: '#000', fontWeight: 400, fontSize: 14, paddingLeft: 5 }}>
                  {titleCase(String(value))}
                </span>
              )}
            />
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      ) : (
        <Box width='100%' my={14.75}>
          <BuilderEmptyStateView />
        </Box>
      )}
    </Box>
  );
}
